import { Model } from '../base/Model';
export class OrderModel extends Model {
    constructor() {
        super(...arguments);
        this.fields = this.getResetFields();
        this.formErrors = {};
        this.steps = {
            details: ['payment', 'address'],
            order: ['email', 'phone'],
        };
        this.fieldsKeyMapper = {
            payment: 'Способ оплаты',
            email: 'Email',
            phone: 'Телефон',
            address: 'Адрес доставки',
        };
    }
    getStepKey(field) {
        return Object.entries(this.fields).reduce((acc, [key, value]) => {
            return field in value ? (acc = key) : acc;
        }, '');
    }
    setFieldValue(field, value, target) {
        const step = this.getStepKey(field);
        if (step) {
            this.fields[step][field] = value;
            this.validateFields(field, step, target);
        }
    }
    getResetFields() {
        return {
            details: {
                payment: '',
                address: '',
            },
            order: {
                email: '',
                phone: '',
            },
        };
    }
    validateFields(field, step, target) {
        const errors = {};
        if (!target.checkValidity()) {
            errors[field] = target.validationMessage;
        }
        Object.keys(this.fields[step]).forEach((key) => {
            if (!errors[key] && !this.fields[step][key]) {
                errors[key] = `Необходимо указать поле "${this.fieldsKeyMapper[key]}"`;
            }
        });
        this.formErrors = errors;
        this.events.emit('order:errors-change', { step, fields: this.formErrors });
    }
    getFields() {
        return Object.values(this.fields).reduce((acc, val) => (Object.assign(Object.assign({}, acc), val)), {});
    }
    resetState() {
        this.fields = this.getResetFields();
        this.formErrors = {};
    }
}
